// extracted by mini-css-extract-plugin
export default {"title":"user-orders_title__Sabr5","bookingMenuLink":"user-orders_bookingMenuLink__dmga6","active":"user-orders_active__XZ3-A"};